import { H5 } from "@sellar-io/components";
import { formatCurrency } from "@sellar-io/common";

export const DiscountedPrice = ({
  productPriceTier,
}: {
  productPriceTier?: {
    basePrice: number | null;
    fullPrice: number;
    price: number;
  } | null;
}) => {
  if (!productPriceTier) return null;

  const showStrikeThrough =
    productPriceTier.fullPrice !== productPriceTier.price ||
    (productPriceTier.basePrice ?? 0) > productPriceTier.price;

  return (
    <div className={"flex place-content-end items-center"}>
      {showStrikeThrough ? (
        <>
          <span className={"text-sm text-zinc-500 line-through"}>
            {formatCurrency(
              productPriceTier.basePrice ?? productPriceTier.fullPrice,
              "GBP",
            )}
          </span>
          {"  "}
        </>
      ) : null}
      <H5 className={"w-20 text-right"}>
        {formatCurrency(productPriceTier.price, "GBP")}
      </H5>
    </div>
  );
};
